export default "__VITE_ASSET__9be33b6f__"